<template>
    <rkm-area
        type="fieldset"
        title="Condições de saúde atual"

    >
        <Form
            :form="form"
            :model="model"
        />
    </rkm-area>
</template>

<script>
// Components.
import Form from './Form'

export default {
    components: { Form },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    }
}
</script>